angular.module('gym.tasks').factory('LoadDebouncedDueTasksService', ["$q", "Tasks", function($q, Tasks) {
  var loadDebounced;
  loadDebounced = _.debounce((function(params, deferred) {
    return Tasks.all('due').getList(params).then(function(data) {
      return deferred.resolve(data);
    }, function(data) {
      return deferred.reject(data);
    });
  }), 1000);
  return {
    load: function(params) {
      var deferred;
      deferred = $q.defer();
      loadDebounced(params, deferred);
      return deferred.promise;
    }
  };
}]);
